<template>
  <div>
    <div class="banner">
      <div>
        <img src="@/assets/images/logo.png" style="cursor: pointer;" @click="jump({
          path:'/index'
        })" width="293px" />
      </div>
      <div>
        <div>
          <!-- <img src="@/assets/images/dh.png" /> -->
          <div>
            <p class="tip" >国家社会科学基金资助期刊</p>
            <!-- <p>010-68034153</p> -->
          </div>
        </div>
      </div>
    </div>
    <div style="background-color: #edf4ff" v-if="ary1.indexOf(route.path)==-1" >
      <div class="nav">
        <template v-for="(item,index) in navList" >
          <p :class="route.fullPath.indexOf(item.cover)!==-1?'cover':null" v-if="!item.children"  @click="jump(item)" style="position: relative;" @mouseenter="currIndex=index" @mouseleave="currIndex=-1" >
          <span>
            {{ item.name }}
          </span>
         <div style="position: absolute;" class="xl" v-if="index===currIndex"  >
          <li v-for="i in item.children" >
          {{i.name}}
          </li>
         </div>
        </p>
        <p v-else :class="(route.fullPath.indexOf(item.cover)!==-1||route.fullPath.indexOf(item.cover1)!==-1||route.fullPath.indexOf(item.cover2)!==-1)?'cover':null"  style="position: relative;" @mouseenter="currIndex=index" @mouseleave="currIndex=-1" >
          <span>
            {{ item.name }}
          </span>
         <div style="position: absolute;" class="xl" v-if="index===currIndex"  >
          <li v-for="i in item.children" @click="jump(i,item.name)" style="line-height: 20px;padding:15px 5px;" >
          {{i.name}}
          </li>
         </div>
        </p>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter,useRoute } from "vue-router";
import {
  GetSiteContentPageList,
  GetAPPNavigationChild
} from "@/utils/index.js";
let ary1 = ["/enIndex", "/enIssue", "/enDetail", "/enAbout","/enDetail1"];
const router = useRouter();
const route =useRoute()
let currIndex = ref(-1)
let navList = ref([
  {
    name: "本站首页",
    path: "/index",
    cover:'/index'
  },
  {
    name: "关于我们",
    path: "/detail",
    channelId: 11780,
    id: 157466,
    cover:'11780',
    cover1:'11781',
    cover2:'12814',
    children:[
      {
        name: "《经济研究》介绍",
        path: "/detail",
        channelId: 11780,
        id: 1,
      },
      {
        name: "编辑委员会",
        path: "/detail",
        channelId: 11780,
        id: 1,
      },
      {
        name: "编辑部人员",
        path: "/detail",
        channelId: 11780,
        id: 157466,
      }
    ]
  },
  // {
  //   name: "编委委员会",
  //   path: "/detail",
  //   channelId: 11781,
  //   id: 158613,
  // },
  {
    name: "投稿须知",
    path: "/detail",
    channelId: 11782,
    id: 157467,
    cover:'11782',
    cover1:'12816',
    cover2:'12815',
    children:[
      {
        name: "投稿注意事项",
        path: "/detail",
        channelId: 11780,
        id: 157466,
      },
      {
        name: "《经济研究》稿件体例要求",
        path: "/detail",
        channelId: 11780,
        id: 157466,
      },
      {
        name: "参考文献索引及附录体例说明",
        path: "/detail",
        channelId: 11780,
        id: 157466,
      },
      {
        name: "审稿流程",
        path: "/detail",
        channelId: 11780,
        id: 157466,
      }
    ]
  },
  {
    name: "我要订阅",
    path: "/detail",
    channelId: 11783,
    id: 157468,
    cover:'/detail?id=157468&channelId=11783'
  },
  {
    name: "联系我们",
    path: "/detail",
    channelId: 11784,
    id: 157476,
    cover:'/detail?id=157476&channelId=11784'
  },
  {
    name: "English",
    path: "/enIndex",
  },
]);

// GetAPPNavigationChild({
//   ParentID:12811,
//   Journalid:201803050001
// }).then(res=>{
//   console.log(res,'这是啥啊')
// })

GetSiteContentPageList({
  channeID: 12811,
  CurrentPage: 1,
  PageSize: 10,
}).then((res) => {
  let data = res.data.reverse()
  navList.value[1].children = data.map(item=>{
    return {
      name: item.title,
        path: "/detail",
        channelId: item.linkUrl,
        id: item.abstruct,
    }
  });
});


GetSiteContentPageList({
  channeID: 12812,
  CurrentPage: 1,
  PageSize: 10,
}).then((res) => {
  navList.value[2].children = res.data.map(item=>{
    return {
      name: item.title,
        path: "/detail",
        channelId: item.linkUrl,
        id: item.abstruct,
    }
  });
});

function jump(params,title) {
  router.push({
    path: params.path,
    query: {
      id: params.id,
      channelId: params.channelId,
      title:params.name,
      title1:title
    },
  });
}


</script>

<style lang="less" scoped>
.banner {
  min-width: 1280px;
  padding: 0 180px 0 130px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #074173;
  height: 220px;
  > div:last-of-type {
    > div {
      display: flex;
      color: #fff;
      img {
        margin-right: 20px;
        width: 44px;
      }
    }
  }
}
.nav {
  margin: 0 auto;
  width: 1280px;
  height: 48px;
  display: flex;
  justify-content: space-around;
  background-color: #edf4ff;
  p {
    width: 144px;
    // flex: 1;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #1f2440;
    line-height: 48px;
    text-align: center;
    font-style: normal;
    cursor: pointer;
    span {
      
    }
  }
  p:hover {
    background-color: #c7deff;
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: 600;
    color: #000000;
  }
  .cover{
    background-color: #c7deff;
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: 600;
    color: #000000;
  }
}
.xl{
  width: 144px;
  position: absolute;
  background-color: #fff;
  /* 自动布局子元素 */
position: static;
width: 144px;
border-radius: 0px 0px 4px 4px;
opacity: 1;
box-shadow: inset 0px -1px 0px 0px #E8E8E8;
	
z-index: 2;
  li{
    list-style: none;
    padding: 4px 16px;
    box-shadow: inset 0px -1px 0px 0px #E8E8E8;
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: normal;
    line-height: 36px;
    text-align: center;
    letter-spacing: 0px;
    color: #333333;
  }
  li:hover{
    background-color: #EDF4FF;
  }
}

::v-deep .el-carousel__arrow{
  background-color: rgba(0,0,0,.5) !important;
}
.tip{
opacity: 1;
font-family: Alibaba PuHuiTi 2.0;
font-size: 24px;
font-weight: normal;
line-height: 60px;
letter-spacing: 0px;
color: #FFFFFF;
}
</style>
